module.exports = __webpack_public_path__ + "img/ic_youtube.e968028c.svg";